import { Injectable } from '@angular/core'

@Injectable()

export class DomHelper {

    addClass(element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter(function (name) {
                    return name !== classString;
                })
                .concat(classString)
                .join(' ');
        }
    }

    removeClass(element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter(function (name) {
                    return name !== classString;
                })
                .join(' ');
        }
    }


    isMobile() {
        const SMALL_SCREEN_BREAKPOINT = 768;
        return window.screen.width < SMALL_SCREEN_BREAKPOINT;
    }

    scrollFrom(parent, child, distance) {
        parent.scrollTo(0, child['offsetTop'] + distance)
    }

}
